import { useEffect, useState } from "react"
import { Alert } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6"
import { IoMdClose } from "react-icons/io"
import { useLocation } from "react-router"

import Button from "@/components/Button/Button"
import DirectionText from "@/components/DirectionText/DirectionText"
import { useTrackClickAdMutation } from "@/queries/mutations"
import { useRelevantAdvertisement } from "@/queries/queries"
import { useStore } from "@/zustand/store"

import styles from "./AdvertisementBanner.module.css"

export default function AdvertisementBanner() {
  const { i18n } = useTranslation()

  const authData = useStore((state) => state.authData)

  const { data: advertisement, isLoading } = useRelevantAdvertisement({
    enabled: Boolean(authData),
  })

  const trackClick = useTrackClickAdMutation()

  const adBannerDismissed = useStore((state) => state.adBannerDismissed)

  const [show, setShow] = useState(false)

  const location = useLocation()

  useEffect(() => {
    setShow(true)
  }, [location.pathname])

  useEffect(() => {
    if (advertisement && !adBannerDismissed) {
      setShow(true)
    } else {
      setShow(false)
    }
  }, [advertisement, adBannerDismissed])

  const handleDismiss = () => {
    setShow(false)
  }

  if (isLoading || !advertisement || !show) {
    return null
  }

  return (
    <Alert
      variant="info"
      dismissible={false}
      show={show}
      className={styles.banner}
    >
      <div className={styles.content}>
        <div className={styles.textContent}>
          <DirectionText
            className={styles.title}
            style={{ textAlign: "center" }}
          >
            {advertisement.title}
          </DirectionText>
          <DirectionText
            className={styles.description}
            style={{ textAlign: "center" }}
          >
            {advertisement.description}
          </DirectionText>

          {advertisement.cta_link && (
            <Button
              className={styles.ctaButton}
              onClick={() => {
                if (advertisement.cta_link) {
                  trackClick.mutate(advertisement)
                  window.open(
                    advertisement.cta_link,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              }}
            >
              {i18n.language === "ar" ? (
                <>
                  {advertisement?.cta_button_text_ar || "اعرف المزيد"}
                  <FaArrowLeft />
                </>
              ) : (
                <>
                  {advertisement?.cta_button_text || "Learn More"}
                  <FaArrowRight />
                </>
              )}
            </Button>
          )}
        </div>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.closeButton}
            onClick={handleDismiss}
            aria-label="Close"
          >
            <IoMdClose size={20} />
          </button>
        </div>
      </div>
    </Alert>
  )
}
